export enum USER_ACTION_TYPE_ENUMS {
  AUTHENTICATED = 'signedIn',
  AUTHENTICATION_ERROR = 'signIn_failure',
  SIGN_OUT = 'signedOut',
  SET_JWT = 'SET_JWT',
  START_LOADING= 'loading',
  USER_NOT_FOUND='no_user'
}
// "signInWithRedirect" | "signInWithRedirect_failure" | "tokenRefresh" | "tokenRefresh_failure" | "customOAuthState" | "signedIn" | "signedOut"
